<template>

<app-wrapper v-on:click.native="onClick" class="slide" :style="{backgroundImage: background}" :class="{'is-link': slide.type === $constants.transition.text, 'is-active': active, 'is-left': position === 'left', 'is-right': position === 'right'}">

    <app-inner v-if="slide.type === $constants.transition.search" class="slide-search">

        <div class="slide-search-title">{{ slide.title }}</div>
        <div class="slide-search-subtitle" v-if="slide.subtitle">{{ slide.subtitle }}</div>

        <div class="slide-search-box">

            <input class="slide-search-box-input" type="text" v-model="search" :placeholder="slide.placeholder" v-on:focus="$emit('focus')" v-on:blur="$emit('blur')" v-on:keypress.enter="onSearch" />

            <app-icon class="slide-search-box-icon" name="search" v-on:click.native="onSearch" />

        </div>

    </app-inner>

    <app-inner v-if="slide.type === $constants.transition.text" class="slide-text">

        <div class="slide-text-title" v-html="textTitle"></div>

    </app-inner>

</app-wrapper>

</template>

<script>

export default {

    props: ['active', 'slide', 'position'],

    data: function() {

        return {
            search: ''
        }

    },

    computed: {

        background: function() {

            return 'url(' + this.slide.image + ')'

        },

        textTitle: function() {

            return '<span>' + this.slide.title.split(' ').join('</span><span>') + '</span>'

        }

    },

    methods: {

        onSearch: function() {

            if (this.search !== '') {

                this.$router.push({
                    name: 'Search',
                    query: {
                        text: this.search
                    }
                })

            }

        },

        onClick: function() {

            if (this.slide.type === this.$constants.transition.text) {

                window.location.href = this.slide.url

            }

        }

    }

}

</script>

<style scoped>

.slide {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-position: 50% 50%;
    background-size: cover;
    transition: all 300ms ease-in-out;
}

.slide.is-link {
    cursor: pointer;
}

.slide.is-left {
    transform: translateX(-100%);
}

.slide.is-right {
    transform: translateX(100%);
}

.slide.is-active {
    transform: translateX(0%);
}

.slide-text {
    justify-content: center;
    align-items: flex-start;
}

.slide-text-title {
    font-family: grueber,serif;
    color: #fff;
    line-height: 48px;
    font-size: 48px;
    max-width: 50%;
}

.is-tablet .slide-text-title {
    font-size: 32px;
    line-height: 32px;
    margin-left: 64px;
}

.is-mobile .slide-text-title {
    font-size: 20px;
    line-height: 20px;
    margin-left: 8px;
}

.slide-text-title >>> span {
    display: inline-block;
    background-color: #00afd4;
    padding: 5px 10px;
}

.slide-search {
    justify-content: center;
    align-items: center;
}

.slide-search-title {
    font-size: 32px;
    font-family: grueber,serif;
    color: #fff;
    text-shadow: 0px 0px 24px rgba(0, 0, 0, 0.75);
    text-shadow: black;
    text-transform: uppercase;
}

.is-mobile .slide-search-title {
    font-size: 24px;
}

.slide-search-subtitle {
    font-family: grueber,serif;
    font-size: 16px;
    text-shadow: 0px 0px 24px rgba(0, 0, 0, 0.75);
    margin-top: 10px;
    color: #fff;
    text-transform: lowercase;
}

.slide-search-box {
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    max-width: 450px;
    height: 64px;
    margin-top: 30px;
    display: flex;
    flex-direction: row;
}

.is-mobile .slide-search-box {
    height: 40px;
}

.slide-search-box-input {
    flex-grow: 1;
    line-height: 64px;
    padding: 0px 20px;
    font-size: 16px;
    color: var(--color-grey-dark);
}

.is-mobile .slide-search-box-input {
	line-height: 40px;
}

.slide-search-box-input::placeholder {
    color: var(--color-grey);
}

.slide-search-box-icon {
    flex-shrink: 0;
    cursor: pointer;
    width: 64px;
    line-height: 64px;
    font-size: 24px;
    color: var(--color-grey);
    text-align: center;
    transition: all 100ms linear;
}

.is-mobile .slide-search-box-icon {
    line-height: 40px;
}

.is-desktop .slide-search-box-icon:hover {
    color: var(--color-grey-dark);
}

</style>